module.exports = __webpack_public_path__ + "static/media/menu_companies.0100f193.svg";